"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const config_1 = require("config");
const Layout_1 = __importDefault(require("./Layout"));
const views_1 = require("./views");
const DocUpload_1 = __importDefault(require("./views/DocUpload"));
function Routes() {
    const location = (0, react_router_dom_1.useLocation)();
    const history = (0, react_router_dom_1.useHistory)();
    const { path } = (0, react_router_dom_1.useRouteMatch)();
    const from = location.state?.from;
    (0, react_1.useEffect)(() => {
        if (from !== '/merchant-portal') {
            history.push({
                pathname: config_1.MERCHANT_PORTAL_URL,
                state: { from: '/new-deal' },
            });
        }
    }, []);
    return ((0, jsx_runtime_1.jsx)(Layout_1.default, { children: (0, jsx_runtime_1.jsxs)(react_router_dom_1.Switch, { children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: path + '/doc-upload', children: (0, jsx_runtime_1.jsx)(DocUpload_1.default, { displayContinue: false, makeSyncCallback: true }) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "*", children: (0, jsx_runtime_1.jsx)(views_1.VerifyStoreInformation, {}) })] }) }));
}
exports.default = Routes;
